module.exports = __webpack_public_path__ + "static/media/malt.a66a4e94.mp3";